import { settingResponseSchema, settingTestResultSchema, upsertSettingBodySchema, settingTypeSchema, } from '../contracts/settings';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
/**
 * Get an organization setting by type.
 * Authorization: Owner or Manager only.
 */
export async function getOrgSetting(client, organizationId, settingType) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedType = parseSchema(settingTypeSchema, settingType);
    const response = await client.get(`/organizations/${validatedId}/settings/${validatedType}`);
    return parseSchema(settingResponseSchema, response);
}
/**
 * Create or update an organization setting by type.
 * Optional query params are setting-type specific (e.g. SIEM: test=only | true | false).
 * When params.test=only: response is SettingTestResult (nothing persisted).
 * Otherwise response is SettingResponse.
 * Authorization: Owner or Manager only.
 */
export async function upsertOrgSetting(client, organizationId, settingType, body, options) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedType = parseSchema(settingTypeSchema, settingType);
    const validatedBody = parseSchema(upsertSettingBodySchema, body);
    const response = await client.put(`/organizations/${validatedId}/settings/${validatedType}`, validatedBody, options?.params ? { params: options.params } : undefined);
    if (options?.params?.test === 'only') {
        return parseSchema(settingTestResultSchema, response);
    }
    return parseSchema(settingResponseSchema, response);
}
/**
 * Delete (disconnect) an organization setting by type.
 * Authorization: Owner or Manager only.
 */
export async function deleteOrgSetting(client, organizationId, settingType) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedType = parseSchema(settingTypeSchema, settingType);
    await client.delete(`/organizations/${validatedId}/settings/${validatedType}`);
}
/**
 * Get an account (user) setting by type.
 * Requires enforce_policy_mode feature flag for enforcement-severity-threshold.
 */
export async function getAccountSetting(client, settingType) {
    const validatedType = parseSchema(settingTypeSchema, settingType);
    const response = await client.get(`/account/settings/${validatedType}`);
    return parseSchema(settingResponseSchema, response);
}
/**
 * Create or update an account (user) setting by type.
 * Body is the type-specific config (e.g. { severity } for enforcement-severity-threshold).
 * Requires enforce_policy_mode feature flag for enforcement-severity-threshold.
 */
export async function upsertAccountSetting(client, settingType, config) {
    const validatedType = parseSchema(settingTypeSchema, settingType);
    const response = await client.put(`/account/settings/${validatedType}`, config);
    return parseSchema(settingResponseSchema, response);
}
//# sourceMappingURL=settings.js.map